import React, { Component } from 'react';
import Ad from './Ad';
import './AppAdditionalInfos.css';
import { getRegionFullName, camelize, formatDate } from "./Helper/functions";
import PropTypes from 'prop-types';

class AppAdditionalInfos extends Component {

	render() {

		let holidayData = this.props.data;
		let dateFrom = new Date();
		let dateTo = new Date();
		let year = this.props.year;
		let region = this.props.region;
		let schoolHolidays = [];
		let specialSchoolHolidays = [];

		let compare = (a, b) => {

			const dateA = a.date;
			const dateB = b.date;

			let comparison = 0;
			if (dateA > dateB) {
				comparison = 1;
			} else if (dateA < dateB) {
				comparison = -1;
			}
			return comparison;
		}

		switch(this.props.dateType) {
			// Public Holidays
			case 1:
				if(holidayData.public) {
					holidayData = holidayData.public;
					holidayData.sort(compare);
				}

				return (
					<div className="AppAdditionalInfos public">

						<div className="column left">
							<h1>Feiertage Österreich {year}</h1>
							<div className="table">
								{Object.values(holidayData).map((holiday) => {
									dateFrom.setTime(holiday['date']*1000);
									return (
										<div className="row" key={holiday.name}>
											<span className="date">{formatDate(dateFrom)}</span>
											<span>{holiday.name}</span>{(holiday.legal ? '' : '*')}
										</div>
									)
								})}
							</div>
							<div className="notes">* Kein gesetzlicher Feiertag</div>
							<div className="more"><a href="https://www.feiertage-oesterreich.at/" className="info" target="_blank">Weitere Infos zu den Feiertagen in Österreich</a></div>
						</div>

						<div className="column right">
							<Ad type="medium-rectangle" />
						</div>
					</div>
				);
			// School Holidays
			case 2:

				if(holidayData.school) {

					Object.keys(holidayData.school).map((holidayName) => {
						let holiday = holidayData.school[holidayName];

						if(holiday && holidayName) {

							dateFrom.setTime(holiday['date_from']*1000);
							dateTo.setTime(holiday['date_to']*1000);

							schoolHolidays.push({
								name: holidayName,
								dateFrom: formatDate(dateFrom),
								dateTo: formatDate(dateTo)
							});
						}

						return '';
					});
				}
				if(holidayData.special) {
					for(let i in holidayData.special.date) {
						dateFrom.setTime(holidayData.special.date[i]*1000);
						specialSchoolHolidays.push({
							dateFrom: formatDate(dateFrom, {weekday: 'long', month: 'long'})
						});
					}
				}

				return (
					<div className="AppAdditionalInfos school">

						<div className="column left">
							<h1>Schulferien {getRegionFullName(region)} {year}</h1>
							<div className="table">
								{schoolHolidays.map((item) => {

									let name = camelize(item.name);

									if(item.name !== '5') {
										return (
											<div className="row" key={item.dateFrom}>
												<span className="name">{name}</span>
												<span>{item.dateFrom}</span> -
												<span>
													{(() => {
														if(item.name === 'weihnachtsferien') {
															let d = new Date(parseInt(this.props.year, 10)+1, 0,6);
															return formatDate(d);
														} else {
															return item.dateTo;
														}
													})()}
													</span>
											</div>
										)
									}

									return '';
									
								})}
							</div>

							{specialSchoolHolidays.length > 0 &&
								<div>
									<h2>Schulautonome Tage {getRegionFullName(region)} {year}</h2>
									<div className="table">
										{specialSchoolHolidays.map((item) => {
											return (
											<div className="row" key={item.dateFrom}>
											{item.dateFrom}
											</div>
											)
										})}
									</div>
								</div>
							}

							<div className="more"><a href="https://www.feiertage-oesterreich.at/schulferien/" className="info" target="_blank">Quelle: feiertage-oesterreich.at - Schulferien</a></div>
						</div>

						<div className="column right">
							<Ad type="medium-rectangle" />
						</div>
					</div>
				);
			default:
				return;
		}
	}
}

AppAdditionalInfos.propTypes = {
	year: PropTypes.number.isRequired,
	region: PropTypes.string,
	dateType: PropTypes.number.isRequired,
	data: PropTypes.object.isRequired
}

export default AppAdditionalInfos;



// WEBPACK FOOTER //
// ./src/components/AppAdditionalInfos.js